<template>
  <svg
    id="verifica-t_logo"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 328.6 76"
    xml:space="preserve"
  >
    <path
      class="st1"
      d="M4.7,38c0-19.4,15.7-35.1,35.1-35.1c19.4,0,35.1,15.7,35.1,35.1c0,19.4-15.7,35.1-35.1,35.1
		C20.4,73.1,4.7,57.4,4.7,38z"
    />
    <g>
      <path
        class="st2"
        d="M46.6,47c-0.3,1.7-1.8,3-3.7,3H28.7c-0.6,3.8,2.1,7.3,5.9,7.3h7.5c7.3,0,10.2-3.3,11.8-10.8l2.7-13.4
    c0.7-3.7-2.1-7.1-5.8-7.1L46.6,47z"
      />
      <path
        class="st3"
        d="M33.1,29c0.3-1.7,1.8-3,3.7-3H51c0.6-3.8-2.1-7.3-5.9-7.3h-7.5c-7.3,0-10.2,3.3-11.8,10.8L23,42.9
    c-0.7,3.7,2.1,7.1,5.8,7.1L33.1,29z"
      />
      <path
        class="st3"
        d="M39.8,41.5c2.1,0,3.7-1.7,3.7-3.7c0-2.1-1.6-3.6-3.7-3.6c-2.1,0-3.7,1.5-3.7,3.6
    C36.1,39.9,37.7,41.5,39.8,41.5z"
      />
    </g>
    <g v-if="!mobile">
      <path
        :class=" isDarkTheme ? 'st3': 'st0'"
        d="M84.1,19h7.5l10.4,31h1.2l10.4-31h7.5l-13.5,37.7H97.6L84.1,19z"
      />
      <path
        :class=" isDarkTheme ? 'st3': 'st0'"
        d="M133.2,29.2c7.3,0,12.2,5.1,12.2,12.7v2.6h-19.6c0,5.1,2.1,7.1,7.3,7.1c4.1,0,5.8-1,5.8-3.3h6.5
		c-0.5,5.4-5,9-12.6,9c-8.1,0-13.5-5.6-13.5-14S124.9,29.2,133.2,29.2z M139.4,40c0-3.7-1.9-5.1-6.6-5.1c-4.7,0-6.6,1.5-6.6,5.1
		H139.4z"
      />
      <path
        :class=" isDarkTheme ? 'st3': 'st0'"
        d="M168.2,29.8v6.5h-6.1c-3.1,0-4.5,1.7-4.8,5.9v14.6h-6.5V29.8h5.9l0.5,4.1v0.4c0.9-2.7,3.1-4.5,5.5-4.5H168.2z"
      />
      <path
        :class=" isDarkTheme ? 'st3': 'st0'"
        d="M171.4,17.5c1.9-1.8,4.7-1.8,6.6,0c1.8,1.9,1.8,4.7,0,6.6c-1.9,1.8-4.7,1.8-6.6,0
		C169.6,22.2,169.6,19.4,171.4,17.5z M177.9,29.8v26.9h-6.5V29.8H177.9z"
      />
      <path
        :class=" isDarkTheme ? 'st3': 'st0'"
        d="M195,24.9v10v21.8h-6.5V34.9h-6v-5.1h6v-5.4c0-4.8,3.3-8.1,8.4-8.1h7V22h-6.1C195.8,22,195,22.8,195,24.9z"
      />
      <path
        :class=" isDarkTheme ? 'st3': 'st0'"
        d="M233.4,57.3c-8.3,0-13.8-5.6-13.8-14s5.5-14,13.8-14c7.3,0,12.2,3.8,12.2,9.6h-6.5c0-2.8-1.8-3.9-6.2-3.9
		c-4.8,0-6.8,2.4-6.8,8.3s2,8.3,6.8,8.3c4.6,0,6.5-1.4,6.5-5h6.5C245.8,53,240.8,57.3,233.4,57.3z"
      />
      <path
        :class=" isDarkTheme ? 'st3': 'st0'"
        d="M277.3,29.8v26.9h-5.9l-0.4-3.3c-2,2.4-4.8,3.8-8.2,3.8c-7.5,0-12.6-5.6-12.6-14s5.1-14,12.6-14
		c3.3,0,6.1,1.3,8.1,3.7v-3.2H277.3z M270.8,43.3c0-6-2-8.4-7.1-8.4c-5.2,0-7.2,2.4-7.2,8.4c0,5.9,2,8.3,7.2,8.3
		C268.8,51.6,270.8,49.2,270.8,43.3z"
      />
      <path
        :class=" isDarkTheme ? 'st3': 'st0'"
        d="M313.5,34.9v13.2c0,2.1,0.8,3,2.8,3h6.1v5.7h-7c-5.1,0-8.4-3.2-8.4-8.1V34.9h-6v-5.1h6v-7h6.5v7h8.9v5.1H313.5
		z"
      />


      <path
        :class=" isDarkTheme ? 'st3': 'st0'"
        d="M200.2,29.8c-1,0-2,0.5-2.6,1.4l-2.7,3.8c0,0,12.7,0,12.7,0v21.8h6.5V29.8L200.2,29.8z"
      />
      <path
        :class=" isDarkTheme ? 'st3': 'st1'"
        d="M300.9,39.6l-2.9,4.2c-0.7,0.9-1.7,1.5-2.9,1.5h-13.9l2.9-4.2c0.7-0.9,1.7-1.5,2.9-1.5H300.9z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    responsive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isDarkTheme() {
      return this.$vuetify.theme.current.dark
    },
    mobile() {
      return this.responsive && this.$vuetify.display.mdAndDown
    },
  },
}

</script>

<style scoped>
#verifica-t_logo {
  width: 210px;
}

.st0 {
  fill: #12284c;
}

.st1 {
  fill: #00c1b4;
}

.st2 {
  fill: #007473;
}

.st3 {
  fill: #ffffff;
}
</style>
